import { _post, _get, _delete } from "./Axios";

export default class AspekKinerjaApi {
  static get(id = null) {
    if (id == null) {
      return _get("kpi/aspekkinerja");
    } else {
      return _get("kpi/aspekkinerja/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/aspekkinerja?" + params);
  }
  static post(data) {
    return _post("kpi/aspekkinerja", data);
  }
  static update(id, data) {
    return _post("kpi/aspekkinerja/" + id, data);
  }
  static delete(id) {
    return _delete("kpi/aspekkinerja/" + id);
  }
}
